(function() {
  document.querySelectorAll('.cev-product[data-section-id]').forEach(function(section) {
    var sectionId = section.dataset.sectionId;
    var productId = section.dataset.productId;

  const countdown = section.querySelector('.cev-countdown');
  if (countdown) {
    function updateCountdown() {
      const endAttr = countdown.dataset.endDate;
      let target;
      if (endAttr) { target = new Date(endAttr); } else {
        target = new Date();
        target.setDate(target.getDate() + ((7 - target.getDay()) % 7 || 7));
        target.setHours(23, 59, 59, 0);
      }
      const now = new Date();
      let diff = Math.max(0, target - now);
      const d = Math.floor(diff / 86400000); diff -= d * 86400000;
      const h = Math.floor(diff / 3600000); diff -= h * 3600000;
      const m = Math.floor(diff / 60000); diff -= m * 60000;
      const s = Math.floor(diff / 1000);
      const pad = n => String(n).padStart(2, '0');
      const map = { d, h, m, s };
      countdown.querySelectorAll('[data-cd]').forEach(el => { el.textContent = pad(map[el.dataset.cd]); });
    }
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  section.querySelectorAll('.cev-swatch').forEach(s => {
    s.addEventListener('click', () => {
      section.querySelectorAll('.cev-swatch').forEach(x => x.classList.remove('cev-active'));
      s.classList.add('cev-active');
      const colorName = section.querySelector('#cev-color-name-' + sectionId);
      if (colorName) colorName.textContent = s.dataset.color;
      const variantId = s.dataset.variantId;
      const hidden = section.querySelector('#cev-variant-id-' + sectionId);
      if (hidden && variantId) hidden.value = variantId;
      const swatchImg = s.querySelector('img');
      const mainImg = section.querySelector('.cev-main-shot img');
      if (mainImg && swatchImg) mainImg.src = swatchImg.src.replace(/width=\d+/, 'width=1200');
    });
  });

  section.querySelectorAll('.cev-gallery-item').forEach(item => {
    item.addEventListener('click', () => {
      const img = item.querySelector('img');
      if (!img) return;
      const overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;background:rgba(33,0,1,0.96);z-index:9999;display:flex;align-items:center;justify-content:center;cursor:zoom-out;padding:40px;';
      const big = document.createElement('img');
      big.src = img.src;
      big.style.cssText = 'max-width:90%;max-height:90%;object-fit:contain;';
      overlay.appendChild(big);
      overlay.addEventListener('click', () => overlay.remove());
      document.body.appendChild(overlay);
    });
  });

  const addonCard = section.querySelector('.cev-addon-card');
  if (addonCard) {
    const addonBtn = addonCard.querySelector('.cev-addon-action');
    let addonAdded = false;
    addonCard.addEventListener('click', (e) => {
      if (e.target.closest('.cev-addon-action') === addonBtn || e.target === addonCard) {
        addonAdded = !addonAdded;
        if (addonAdded) { addonCard.classList.add('cev-added'); addonBtn.textContent = '✓ Added'; }
        else { addonCard.classList.remove('cev-added'); addonBtn.textContent = '+ Add'; }
      }
    });
  }

  const form = section.querySelector('.cev-form');
  const mobileBtn = section.querySelector('.cev-mobile-cta-btn');
  const mobileSticky = section.querySelector('.cev-mobile-sticky');

  // Listen for all common cart open/close events from Kaching and other apps
  if (mobileSticky) {
    const hideSticky = () => { mobileSticky.style.display = 'none'; };
    const showSticky = () => { mobileSticky.style.display = ''; };
    ['cart:open','cart:opened','drawer:open','drawer:opened','cartOpen','drawerOpen',
     'theme:cart:open','ajax-cart:open','cart-open','sidebar:open'].forEach(evt => {
      document.addEventListener(evt, hideSticky);
      window.addEventListener(evt, hideSticky);
    });
    ['cart:close','cart:closed','drawer:close','drawer:closed','cartClose','drawerClose',
     'theme:cart:close','ajax-cart:close','cart-close','sidebar:close'].forEach(evt => {
      document.addEventListener(evt, showSticky);
      window.addEventListener(evt, showSticky);
    });
  }

  async function addToCart(variantId, additionalItems) {
    const items = [{ id: variantId, quantity: 1 }];
    if (additionalItems) items.push(...additionalItems);
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      if (!res.ok) throw new Error('Add to cart failed');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) { console.error('CEV cart error:', err); window.location.href = '/cart'; }
  }

  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = form.querySelector('input[name="id"]').value;
      const items = [];
      if (addonCard && addonCard.classList.contains('cev-added')) items.push({ id: parseInt(addonCard.dataset.addonVariantId, 10), quantity: 1 });
      await addToCart(parseInt(variantId, 10), items);
    });
  }

  if (mobileBtn && mobileSticky) {
    mobileBtn.addEventListener('click', () => {
      // Hide immediately on tap — before the fetch
      mobileSticky.style.display = 'none';
      const variantId = form.querySelector('input[name="id"]').value;
      const items = [];
      if (addonCard && addonCard.classList.contains('cev-added')) items.push({ id: parseInt(addonCard.dataset.addonVariantId, 10), quantity: 1 });
      addToCart(parseInt(variantId, 10), items);
    });
  }

  const recsContainer = section.querySelector('[data-recommendations]');
  if (recsContainer) {
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(r => r.json())
      .then(data => {
        if (!data || !data.products || !data.products.length) { recsContainer.parentElement.style.display = 'none'; return; }
        recsContainer.innerHTML = data.products.map(p => `<div class="cev-product-card"><a href="${p.url}"><div class="cev-product-card-img"><img loading="lazy" src="${p.featured_image}" alt="${p.title}"></div><h4>${p.title}</h4><div class="cev-product-card-price">$${(p.price/100).toFixed(2)}</div></a><button type="button" class="cev-product-card-add" data-variant-id="${p.variants[0].id}">+ Add to Cart</button></div>`).join('');
        recsContainer.querySelectorAll('.cev-product-card-add').forEach(btn => {
          btn.addEventListener('click', async (e) => { e.preventDefault(); await addToCart(parseInt(btn.dataset.variantId, 10), []); });
        });
      })
      .catch(() => { recsContainer.parentElement.style.display = 'none'; });
  }
  });
})();